import { render, staticRenderFns } from "./PCLottery.vue?vue&type=template&id=5c32a541&"
import script from "./PCLottery.vue?vue&type=script&lang=js&"
export * from "./PCLottery.vue?vue&type=script&lang=js&"
import style0 from "./PCLottery.vue?vue&type=style&index=0&id=5c32a541&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports